module.exports = __webpack_public_path__ + "static/media/draugiem.9431f21f.svg";